import React, { useEffect, useState } from "react";
import "./styles.css";
import InlineModal from "../info-modal/infoModal";
import axios from "axios";

const EditCompanyModal = ({ company, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    commercial_name: company.name || "",
    document: company.nit || "",
    address: company.address || "",
    city: "",
    contact_number: company.contact_number || "",
    email: company.email || "",
    rut_document: null,
    commerce_document: null,
  });
  const [errors, setErrors] = useState({});
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [cities, setCities] = useState([]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
    setErrors((prev) => ({ ...prev, [key]: "" }));
  };

  const handleFileChange = (key, file) => {
    setFormData((prev) => ({ ...prev, [key]: file }));
    setErrors((prev) => ({ ...prev, [key]: "" }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.commercial_name.trim())
      newErrors.commercial_name = "Este campo es obligatorio.";
    if (!/^\d+$/.test(formData.document))
      newErrors.document = "Ingresa solo números válidos.";
    if (!formData.address.trim())
      newErrors.address = "Este campo es obligatorio.";
    if (!formData.city.trim()) newErrors.city = "Este campo es obligatorio.";
    if (!/^\d{10,}$/.test(formData.contact_number))
      newErrors.contact_number = "El número debe tener al menos 10 dígitos.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Revisa el formato del correo electrónico.";
    return newErrors;
  };

  const handleSubmit = () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setShowValidationModal(true);
      return;
    }
    onSubmit(formData);
  };

  const renderError = (key) =>
    errors[key] ? (
      <small className="edit-company-modal-label-error">{errors[key]}</small>
    ) : null;

  useEffect(() => {
    axios.get("/data/colombia-cities.json").then((res) => {
      setCities(res.data);
    });
  }, []);

  useEffect(() => {
    if (cities.length > 0 && company.city) {
      const matchedCity = cities.find((c) => c.label === company.city);
      if (matchedCity) {
        setFormData((prev) => ({
          ...prev,
          city: matchedCity.label,
        }));
      }
    }
  }, [cities, company.city]);

  return (
    <>
      <div className="edit-company-modal-overlay">
        <div className="edit-company-modal-content p-4 py-5 gap-3">
          <div className="edit-company-modal-close position-relative w-100">
            <div
              className="training-modal-close position-absolute top-0 end-0 p-0"
              onClick={onClose}
              aria-label="Cerrar modal"
            >
              <i className="bi bi-x fs-4 cursor-pointer"></i>
            </div>
          </div>

          <h5 className="edit-company-modal-title text-center m-0">
            Editar <span className="fw-bold">información del centro</span>
          </h5>

          <p className="edit-company-modal-subtitle text-center m-0">
            Actualiza los datos de contacto y ubicación de tu gimnasio. Estos
            serán visibles para tus usuarios y necesarios para comunicaciones
            oficiales.
          </p>

          <div className="edit-company-modal-line align-items-start"></div>

          <div className="d-flex flex-column w-100 gap-3">
            <div className="d-flex flex-column gap-1">
              <label className="edit-company-modal-input-label">
                Nombre del centro
              </label>
              <input
                type="text"
                className="input-style-elevva edit-company-modal-input"
                value={formData.commercial_name}
                onChange={(e) =>
                  handleChange("commercial_name", e.target.value)
                }
              />
              {renderError("commercial_name")}
            </div>

            <div className="d-flex flex-column gap-1">
              <label className="edit-company-modal-input-label">CC / NIT</label>
              <input
                type="text"
                className="input-style-elevva edit-company-modal-input w-50"
                value={formData.document}
                onChange={(e) => handleChange("document", e.target.value)}
              />
              {renderError("document")}
            </div>

            <div className="d-flex flex-column gap-1">
              <label className="edit-company-modal-input-label">
                Dirección
              </label>
              <input
                type="text"
                className="input-style-elevva edit-company-modal-input"
                value={formData.address}
                onChange={(e) => handleChange("address", e.target.value)}
              />
              {renderError("address")}
            </div>

            <div className="d-flex flex-column gap-1">
              <label className="edit-company-modal-input-label">Ciudad</label>
              <select
                className="edit-company-modal-input px-2"
                value={formData.city}
                onChange={(e) => handleChange("city", e.target.value)}
              >
                <option value="">Ciudad</option>
                {cities.map((city) => (
                  <option key={city.value} value={city.label}>
                    {city.label}
                  </option>
                ))}
              </select>
              {renderError("city")}
            </div>

            <div className="d-flex flex-column gap-1">
              <label className="edit-company-modal-input-label">
                Número de contacto
              </label>
              <input
                type="text"
                className="input-style-elevva edit-company-modal-input w-50"
                value={formData.contact_number}
                onChange={(e) => handleChange("contact_number", e.target.value)}
              />
              {renderError("contact_number")}
            </div>

            <div className="d-flex flex-column flex-md-row justify-content-between w-100">
              <div className="col-md-6 d-flex flex-column gap-1">
                <label className="edit-company-modal-input-label">RUT</label>
                <div className="custom-file-button position-relative">
                  <input
                    type="file"
                    className="form-control input-style-elevva opacity-0 position-absolute top-0 start-0 w-100 h-100"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) =>
                      handleFileChange("rut_document", e.target.files?.[0])
                    }
                  />
                  <div className="edit-company-modal-input-file">
                    <a
                      className=""
                      href={company.rut_document}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      mirut.pdf
                    </a>
                    <i className="bi bi-upload" style={{ color: "#9DACBD" }} />
                  </div>
                </div>
              </div>

              <div className="col-md-6 d-flex flex-column gap-1">
                <label className="edit-company-modal-input-label">
                  Cámara de Comercio
                </label>
                <div className="custom-file-button position-relative">
                  <input
                    type="file"
                    className="form-control input-style-elevva opacity-0 position-absolute top-0 start-0 w-100 h-100"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={(e) =>
                      handleFileChange("commerce_document", e.target.files?.[0])
                    }
                  />
                  <div className="edit-company-modal-input-file">
                    <a
                      className=""
                      href={company.commerce_document}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      micamaraycomercio.pdf
                    </a>
                    <i className="bi bi-upload" style={{ color: "#9DACBD" }} />
                  </div>
                </div>
              </div>
            </div>

            <div className="d-flex flex-column gap-1">
              <label className="edit-company-modal-input-label">
                Correo electrónico
              </label>
              <input
                type="email"
                className="input-style-elevva edit-company-modal-input"
                value={formData.email}
                onChange={(e) => handleChange("email", e.target.value)}
              />
              {renderError("email")}
            </div>
          </div>

          <div className="d-flex justify-content-center gap-2 mt-3 w-100">
            <button
              className="edit-company-modal-button-secondary btn btn-outline-secondary "
              onClick={onClose}
            >
              Cancelar
            </button>
            <button
              className="edit-company-modal-button-primary btn btn-primary"
              onClick={handleSubmit}
            >
              Guardar cambios
            </button>
          </div>
        </div>
      </div>
      {showValidationModal && (
        <InlineModal
          title="Por favor, revisa los campos marcados en rojo."
          primaryAction={{
            label: "Volver a intentar",
            onClick: () => setShowValidationModal(false),
          }}
        />
      )}
    </>
  );
};

export default EditCompanyModal;
